import styled from 'styled-components';

const transitionStyles = {
  entering: 0.5,
  entered: 1,
  exiting: 0.5,
  exited: 0,
};

export const Animation = styled.div`
  opacity: ${props => (props.state ? transitionStyles[props.state] : '0')};
  transition: opacity 150ms cubic-bezier(0.55, 0.085, 0.68, 0.53);
`;
